import {
  ActionCreator,
  BASE_DIALOG_DEFAULT_CONFIG,
  BaseDialog,
  BaseDialogDefinition,
  BaseDialogIngredients,
  SMALL_DIALOG_CONFIG
} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {MatDialogConfig} from '@angular/material/dialog';

export const DEFAULT_NOTIFICATION_CONFIRM_BUTTON_LABEL: string = 'OK';

export interface NotificationDialog<DataType> extends BaseDialog<DataType, void> {
  readonly dialogDefinition: NotificationDialogDefinition;
}

export type NotificationDialogDefinition = Omit<BaseDialogDefinition<void>, 'includeCancelButton' | 'cancelButtonLabel' | 'valueCalculator'>;

export const NOTIFICATION_DIALOG_DEFAULT_CONFIG: MatDialogConfig = {
  ...BASE_DIALOG_DEFAULT_CONFIG,
  ...SMALL_DIALOG_CONFIG
};

export type NotificationDialogIngredients<DataType, DialogComponent extends NotificationDialog<DataType>> =
  Omit<BaseDialogIngredients<DataType, never, DialogComponent>, 'onConfirm' | 'onCancel'>
  & { onConfirm?: ActionCreator<void>; };
